import { SvgIconComponent } from "@material-ui/icons";
import CustomProductOptionIcon from "view/images/CustomProductOptionIcon";
import ListIcon from "@material-ui/icons/List";
import ImageIcon from "@material-ui/icons/Image";
import { ColorSetting } from "view/apps/Supplier/pages/Products/List/components/ProductDetailsDrawer/components/CustomProductOptionConfigModal/types";

export enum CustomProductOptionConfigTab {
  COLOR = "Colour",
  DROPDOWN = "Dropdown",
  IMAGES = "Images",
}

export const CUSTOM_PRODUCT_OPTION_CONFIG_TABS = Object.values(
  CustomProductOptionConfigTab
);

export const CPO_ICON_BY_TAB: Record<
  CustomProductOptionConfigTab,
  SvgIconComponent
> = {
  [CustomProductOptionConfigTab.COLOR]: CustomProductOptionIcon,
  [CustomProductOptionConfigTab.DROPDOWN]: ListIcon,
  [CustomProductOptionConfigTab.IMAGES]: ImageIcon,
};
export const defaultColorConfig: ColorSetting = {
  firstColor: "",
  secondColor: "",
};

export enum ConfirmationModalType {
  RemoveConfig,
  DisableConfig,
  EnableCpo,
  AutoDisableCpo,
}
export const CPO_CONFIRMATION_MODAL_TITLE: Record<
  ConfirmationModalType,
  string
> = {
  [ConfirmationModalType.RemoveConfig]:
    "Are you sure you want to remove this option?",
  [ConfirmationModalType.DisableConfig]:
    "Disabled option will be no more visible in Supplier Shop.  Disable this option?",
  [ConfirmationModalType.EnableCpo]: "Disable Purchase limit?",
  [ConfirmationModalType.AutoDisableCpo]:
    "Custom Product Options will be disabled",
};

export const CPO_CONFIG_INFO_MESSAGE = {
  EMPTY_CONFIGS: "No options to display yet",
  EMPTY_CONFIGS_EDIT_MODE: "Create First Option",
  SUPPLIER_OPTIONS_EMPTY:
    "No Custom Product Options have been configured. To add a CPO, navigate to the Custom Product Options tab and click Add.",
  CUSTOM_CONFIGS_DISABLED:
    "Custom Product Option is disabled. The product is currently visible to exhibitors in its default configuration",
} as const;

export const CPO_AUTO_DISABLE_CONFIRM_DESCRIPTION =
  "None of the options are Active, so Custom Product Options will be switched off automatically if you continue.";

// Shared between the one-at-a-time modal's list and Bulk Configuration's
// grid — both disable the Active toggle at quantity 0 (ticket §7 / AC #18)
// but a disabled control alone doesn't explain why.
export const CPO_ZERO_QUANTITY_TOOLTIP =
  "Set a quantity above 0 to activate this option.";
